export default __webpack_public_path__ + "static/media/avatar1.1d9e1978.png";